'use client';
import { usePathname, useSearchParams } from 'next/navigation';
import { useCallback, useEffect } from 'react';

import { convertUrlSearchParamsToObject } from '../url';

import { trackGtm } from './gtm';
import phog from './posthog/posthog';

export const usePageView = (): void => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  useEffect(() => {
    const eventData = {
      pageTitle: document.title,
      pageUrl: pathname,
      pageKey: pathname,
      params: convertUrlSearchParamsToObject(searchParams),
      ...convertUrlSearchParamsToObject(searchParams),
    };
    trackGtm('virtualPageView', eventData);
    phog.capture('$pageview', eventData);
    // do not add pathname or searchParams to the dependencies array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRouteChange = useCallback(() => {
    const eventData = {
      pageTitle: document.title,
      pageUrl: pathname,
      pageKey: pathname,
      params: convertUrlSearchParamsToObject(searchParams),
      ...convertUrlSearchParamsToObject(searchParams),
    };
    trackGtm('virtualPageView', eventData);
    phog.capture('$pageview', eventData);
  }, [pathname, searchParams]);

  useEffect(() => {
    handleRouteChange();
  }, [handleRouteChange, pathname, searchParams]);
};
